
<div class="w-100 white">
    <d-site-contact-assignment
        v-model   = "showAssignmentDialog"
        :label    = "title"
        :company  = "company"
        :company-role = "companyRole"
        :selected = "contacts"
        :onsite   = "onsite"
        :zus      = "zus"
        @assign   = "onAssigned"
    />

    <c-column-header
        class  = "w-100 primary mb-1"
        :label = "title"
    >
        <template v-slot:pre>
            <div class="ml-n2" style="margin-top: -2px">
                <c-toolbar-button
                    icon     = "mdi-plus"
                    size     = "21"
                    color    = "white"
                    :tooltip = "$t('contact.assign.tooltip')"
                    @click   = "onAssign"
                />
            </div>
        </template>
    </c-column-header>

    <div class="card-area">
        <c-contact-card
            v-for            = "(contact, index) in contacts"
            :contact         = "contact"
            :key             = "contact.id"
            :edit-contact    = "false"
            :enable-unassign = "true"
            :class           = "index < contacts.length - 1 ? 'mb-3' : ''"
            @dissolve        = "onDissolve"
        />
    </div>
</div>
